






























import { Emit, Inject, Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";
import ProjectService from "@/entities/project/project.service";

@Component
export default class FileProjectChangeDialog extends Vue {
  @Prop() file;

  @VModel({ type: Boolean }) dialog: boolean;

  loading = false;

  projects = [];
  newProjectId = 0;

  @Emit()
  onSuccess() {}

  @Inject() refreshPage: () => void;

  async changeProject() {
    let fileGeodeticService = new FileGeodeticService();
    try {
      await fileGeodeticService.changeProject(this.file.id, this.newProjectId);

      (this.$root as any).$bvToast.toast(`Đổi dự án thành công:`, {
        toaster: 'b-toaster-top-center',
        title: 'Success',
        variant: 'success',
        solid: true,
        autoHideDelay: 5000,
      });
      this.onSuccess();
      this.refreshPage();
    } catch (e) {
      (this.$root as any).$bvToast.toast(`Có lỗi xảy ra: ${e}`, {
        toaster: 'b-toaster-top-center',
        title: 'Lỗi',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }

  private static async fetchProjects() {
    const projectService = new ProjectService();
    return await projectService.retrieve({ page: 0, size: 1000 }).then(res => {
      return res.data;
    });
  }

  @Watch('dialog')
  async onDialogChange(val, oldVal) {
    if (!val) {
      this.loading = false;
    } else {
      this.projects = await FileProjectChangeDialog.fetchProjects();
      // this.newProjectId = this.file.project.id;
    }
  }
}
